import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';
import { MANAGE_USERS_ANALYTICS_ACTIONS } from './manage-users-analytics.actions';
import { ManageUsersAnalyticsMessages } from './manage-users-analytics.constants';
import { genericAnalyticsTransformer } from '@shared/tracking/analytics/generic-analytics-transformer';

@Injectable({
  providedIn: 'root',
})
export class ManageUsersAnalyticsService {
  constructor(private store: Store) {}

  trackMakeAdmin() {
    const tracking: Tracking = {
      analytics: {
        data: {
          event: ManageUsersAnalyticsMessages.event,
          capability: ManageUsersAnalyticsMessages.capability,
          file: {
            type: ManageUsersAnalyticsMessages.makeAdmin,
          },
        },
        transformFunc: genericAnalyticsTransformer,
      },
    };
    this.store.dispatch(
      MANAGE_USERS_ANALYTICS_ACTIONS.trackMakeAdmin({ tracking }),
    );
  }

  trackRemoveAdmin() {
    const tracking: Tracking = {
      analytics: {
        data: {
          event: ManageUsersAnalyticsMessages.event,
          capability: ManageUsersAnalyticsMessages.capability,
          file: {
            type: ManageUsersAnalyticsMessages.removeAdmin,
          },
        },
        transformFunc: genericAnalyticsTransformer,
      },
    };
    this.store.dispatch(
      MANAGE_USERS_ANALYTICS_ACTIONS.trackRemoveAdmin({ tracking }),
    );
  }

  trackRemoveUser() {
    const tracking: Tracking = {
      analytics: {
        data: {
          event: ManageUsersAnalyticsMessages.event,
          capability: ManageUsersAnalyticsMessages.capability,
          file: {
            type: ManageUsersAnalyticsMessages.removeUser,
          },
        },
        transformFunc: genericAnalyticsTransformer,
      },
    };
    this.store.dispatch(
      MANAGE_USERS_ANALYTICS_ACTIONS.trackRemoveUser({ tracking }),
    );
  }
}
